var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "textInput" },
    [
      _c("el-input", {
        directives: [
          { name: "uppercase", rawName: "v-uppercase" },
          { name: "trim", rawName: "v-trim" },
          { name: "fth", rawName: "v-fth" },
        ],
        attrs: {
          rows: _vm.rows,
          maxlength: _vm.maxlength,
          placeholder: _vm.placeholder,
          autosize: _vm.autosize,
          spellcheck: "false",
          type: "textarea",
        },
        on: { change: _vm.inputChange },
        model: {
          value: _vm.localValue,
          callback: function ($$v) {
            _vm.localValue = $$v
          },
          expression: "localValue",
        },
      }),
      _vm._v(" "),
      _c("i", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.clearable && _vm.localValue,
            expression: "clearable && localValue",
          },
        ],
        staticClass:
          "clearButton el-input__icon el-icon-circle-close el-input__clear",
        on: {
          click: function ($event) {
            $event.preventDefault()
            _vm.localValue = ""
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }